import { render, staticRenderFns } from "./HealthCheckUpService.vue?vue&type=template&id=35d8ff79&scoped=true"
import script from "./HealthCheckUpService.vue?vue&type=script&lang=js"
export * from "./HealthCheckUpService.vue?vue&type=script&lang=js"
import style0 from "./HealthCheckUpService.vue?vue&type=style&index=0&id=35d8ff79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d8ff79",
  null
  
)

export default component.exports